import { createSlice } from '@reduxjs/toolkit';

export const initialModalState = {
  status: 'closed',
  modalId: '',
  subModalId: '',
  subModalStatus: 'closed',
  data: null
};

// Modal Redux Slice
export const modalSlice = createSlice({
  name: 'modal',
  initialState: initialModalState,
  reducers: {
    openModal(state, action) {
      const newState = { ...state, ...action.payload };
      newState.status = 'open';

      return newState;
    },
    closeModal() {
      return initialModalState;
    },
    openSubModal(state, action) {
      const newState = { ...state, ...action.payload };
      newState.subModalStatus = 'open';
      return newState;
    },
    closeSubModal(state) {
      const newState = { ...state, ...{ subModalId: '' } };
      newState.subModalStatus = 'closed';
      return newState;
    }
  }
});

export const { openModal, closeModal, openSubModal, closeSubModal } =
  modalSlice.actions;

export const selectModalState = (state) => state.modal;
